import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import { sendAuthorMessage } from "../components/sendAuthorMessage";
import getBotResponse from './getBotResponse.js';


// This function is responsible for handling the input textbox for the chat 
// and rendering the reader messages sent + corresponding writer reply
function ChatInput({ globalData, setGlobalData, conversationID, currentChatHistoryData,
    updateChatHistoryData, storyID, userID, retrievedData, botResponse, setBotResponse }) {
    const [isChatHistoryUpdated, setIsChatHistoryUpdated] = useState(false);
    const [messageSent, setMessageSent] = useState(false);

    const [message, setMessage] = useState(''); // State to store the messages users sends 

    // Sends a message if user presses enter
    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();  // This prevents the event from bubbling up so that next point isn't called
            sendMessage();
        }
    };

    // Handles what happens when users send a message
    const sendMessage = async () => {
        if (message.trim() !== "") {
            // Clear the message input
            setMessage('');

            // Update the locally stored version of chatHistory
            const newChatHistory = [
                ...currentChatHistoryData,
                { role: 'user-question', content: message }
            ];
            await updateChatHistoryData(newChatHistory); // Causes a
            setIsChatHistoryUpdated(true);

            await writeToChatHistory(message); // Write user message to chatHistory 
        }
    };

    // Writes messages to user's chat history. This function is used in this file to write both 
    // user and bot messages to history
    const writeToChatHistory = async (userMessage) => {

        const messageData = {
            storyID: storyID, // Replace with the actual story ID
            conversationID: conversationID.current, // Replace with the actual conversation ID
            userID: userID, // Replace with the actual user ID
            text: userMessage,
        };

        try {
            const response = await fetch('https://versify-back-b066d2bc73d1.herokuapp.com/sendUserMessage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(messageData),
            });

            const data = await response.json();
            if (response.ok) {
                setMessageSent(true);  // Indicate the message has been sent successfully.
            } else {
                console.error('Error adding message:', data.error);
            }
        } catch (error) {
            console.error('Failed to send author message:', error);
        }
    };

    

    // Only call bot response once currentChatHistory (our local chat history data) data has been udpated in the sendMessage function 
    // and writeToChatHistory (which writes the newest message to to chatHistory in mongoDB) finished compling.
    useEffect(() => {
        if (isChatHistoryUpdated && messageSent) {
            getBotResponse(
                currentChatHistoryData,
                updateChatHistoryData,
                sendAuthorMessage,
                storyID,
                conversationID,
                userID,
                setBotResponse
            );        
            setIsChatHistoryUpdated(false); // Reset the trigger
            setMessageSent(false); // Reset the trigger
        }
    }, [isChatHistoryUpdated, messageSent]);

    return (
        <TextField
        placeholder={`Have a question ${retrievedData.author.split(' ')[0]} hasn't answered? Chat here with ${retrievedData.author.split(' ')[0]}'s AI clone`}
        variant="outlined"
            sx={{ width: '85%' }}
            maxRows={5}
            // multiline
            // size="small"
            size="medium"
            value={message}
            onChange={(e) => setMessage(e.target.value)} // Update the state as the user types
            onKeyDown={handleKeyPress}

            InputProps={{
                endAdornment: (
                    <SendIcon
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px',
                            cursor: 'pointer'
                        }}
                        onClick={sendMessage}
                    />
                ),
            }}
        />
    );
}

export default ChatInput;
